import { ExportDrop } from '../../../../shared/components/cards/export-drop/ExportDrop'
import { useExportAds } from '../../../../app/api'
import React, { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../app/store/hooks/Redux'
import {
  selectAdOverviewAdsExpanded,
  selectAdOverviewAdsParams,
  selectAdOverviewFilters,
  selectAllowDecloak,
  setAdOverviewFilter,
  toggleAdsExpand,
} from '../../model/adOverviewSlice'
import { IconMinimize } from '../../../../shared/components/icons/IconMinimize'
import { IconMaximize } from '../../../../shared/components/icons/IconMaximize'
import { BpButton } from '../../../../shared/components/buttons/bp-button/BpButton'
import { Switch } from 'antd'
import { BpTooltip } from '../../../../shared/components/cards/tooltip/BpTooltip'
import { IAdOverviewFilter } from '../../model/types/AdOverviewFilter.interface'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'

import styles from './ShoppingAdsPanel.module.scss'

export const ShoppingAdsPanel = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const queryParams = useAppSelector(selectAdOverviewAdsParams)
  const filters = useAppSelector<IAdOverviewFilter>(selectAdOverviewFilters)
  const isExpandAll = useAppSelector(selectAdOverviewAdsExpanded)
  const allowDecloak = useAppSelector(selectAllowDecloak)
  const [exportFile, { isFetching: isLoading }] = useExportAds()

  useEffect(() => {
    dispatch(setAdOverviewFilter({ ...filters, is_decloak: false }))
  }, [filters.project])

  return (
    <span className={clsx(styles.wrapper)}>
      {allowDecloak && (
        <div className={clsx(styles.switchRow)}>
          <Switch
            checked={filters.is_decloak}
            onClick={(e) => {
              dispatch(setAdOverviewFilter({ ...filters, is_decloak: e }))
            }}
          />
          <span className={clsx(styles.label)}>{t('fields.uncloakedAds')}</span>
          <BpTooltip title={t('pages.adOverview.uncloakedAdsTooltip')} />
        </div>
      )}
      <div className={clsx(styles.actions)}>
        <BpButton
          iconLeft={isExpandAll ? <IconMinimize /> : <IconMaximize />}
          size='sm'
          theme='outline'
          type='button'
          onClick={() => dispatch(toggleAdsExpand())}
        ></BpButton>
        <ExportDrop
          columns={[
            { label: t('table.columns.ad'), keys: ['title', 'text', 'finish_domain'] },
            { label: t('table.columns.keyword(s)'), keys: ['keywords'] },
            { label: t('table.columns.redirectLinks'), keys: ['redirects'] },
            { label: t('table.columns.position'), keys: ['position_global'] },
            {
              label: t('table.columns.details'),
              keys: [
                'id',
                'search_screen_url',
                'link_screen_url',
                'countries',
                'cities',
                'engines',
                'devices',
              ],
            },
            { label: t('table.columns.onSiteLinks'), keys: ['additionalRedirects'] },
            { label: t('table.columns.lastFound'), keys: ['last_found'] },
          ]}
          loading={isLoading}
          onExport={(exportParams) => exportFile({ ...queryParams, ...exportParams })}
        />
      </div>
    </span>
  )
}
